import type { ProductCanyonPlatformPlan } from "@forento/core/models/platform"
import { productCanyonPlans } from "@forento/core/models/productCanyon"

import Plan, { PlanBillingInterval, PlanPadding, PlanPrice, PlanTitle } from "./Plan"
import useLtdAddon from "./useLtdAddon"

export default function ProductCanyon({ platformPlan }: { platformPlan: ProductCanyonPlatformPlan }) {
	const addon = useLtdAddon({ platformPlan })
	const plan = Object.values(productCanyonPlans).find(plan => plan.tier === platformPlan.tier)!
	return (
		<div className="flex flex-col gap-4">
			{addon.status === "success" && addon.paymentIntervalComponent}
			<div className="flex flex-wrap gap-8">
				<Plan>
					<PlanTitle>{plan.label}</PlanTitle>
					<PlanPrice>Lifetime</PlanPrice>
					<PlanBillingInterval>Product Canyon plan</PlanBillingInterval>
					<PlanPadding />
					<p>{plan.commission * 100}% base sales commission</p>
					<p>
						{plan.maxAdmins === null
							? "Unlimited admin accounts"
							: `${plan.maxAdmins} admin account${plan.maxAdmins === 1 ? "" : "s"}`}
					</p>
					<p>{plan.aiCredits.toLocaleString("en-US")} AI credits included at activation</p>
					<p>One code redeemed. Your lifetime plan is active.</p>
				</Plan>
				{addon.status === "success" && addon.planComponent}
				{addon.status === "error" && <p>Could not load optional upgrades. Please reload to try again.</p>}
			</div>
		</div>
	)
}
